/**
 * Protected route component
 *
 * Should be used as regular route <Route ... />
 * If user is not logged then it will redirect to login page
 */
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { FunctionComponent, memo, ComponentType } from 'react';

import { PageLoader } from '@astrumu/ui-library';

interface Props {
  component: ComponentType<any>;
}

export const ProtectedRoute: FunctionComponent<Props> = memo(
  ({ component }) => {
    const RouteComponent = withAuthenticationRequired(component, {
      onRedirecting: () => <PageLoader />
    });

    return <RouteComponent />;
  }
);
